module.exports = __webpack_public_path__ + "img/logo.97ef1829.png";